// ReactJS
import * as React from 'react';

// Material UI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { IconButton } from '@mui/material';

// Others NPM's
import { ReactPdfDocument } from './ReactPdfDocument';
import { pdf, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';

// Icons Material UI
import CloseIcon from '@mui/icons-material/Close';
import { useTablon } from '../../contexts/contextGeneral';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "75vw",
    height: "90vh",
    minHeight: "90vh",
    maxHeight: "90vh",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflowY: 'auto',
};

export default function ModalPDF(params) {

    const { getOrden, orden } = useTablon()

    const generateBlob = async () => {
        try {
            const result = await pdf(<ReactPdfDocument base={orden} />).toBlob();
        } catch (error) {
            console.error("Error generando el blob:", error);
        }
    };
    // React.useEffect(() => {
    // }, []);
    
    const [open, setOpen] = React.useState(false);
    
    const handleOpen = async () => {
        const data = await getOrden(params.idOrder);
        generateBlob();
        // console.log(data);
        setOpen(true)
    };
    // console.log(order);

    const handleClose = () => setOpen(false);
    // const childWithProps = React.cloneElement(params.children, { onPDFAction: handleOpen });


    return (
        <div>
            {params.children && React.cloneElement(params.children, { onClick: handleOpen })}
            {!params.children && <Button variant='contained' color='ochre' onClick={handleOpen}>Ver PDF</Button>}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='modalPDFGeneral'
            >

                <Box sx={style}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        color='ochre'
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 40,
                            top: 3,
                            color: "ochre",
                            backgroundColor: "white"
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* {orden !== null && orden.ot} */}
                    {open && (
                        <PDFDownloadLink
                            className='modalPDFViewA'
                            document={<ReactPdfDocument base={orden}  />}
                            fileName={orden.ot + "_" + orden.compania.nombre + ".pdf"}
                        >
                            {({ blob, url, loading, error }) =>
                                loading ? 'Cargando documento...' : 'Descargar'
                            }
                        </PDFDownloadLink>
                    )}
                       
                    {open && (
                        <PDFViewer
                            className='PDFRender'
                            width={'100%'}
                            style={{ height: 'calc(100%)' }}
                        >
                            <ReactPdfDocument base={orden} />
                        </PDFViewer>
                    )}
                </Box>
            </Modal>
        </div>
    );
}
